import {createTheme} from "@mui/material";

const theme = createTheme({
    shape: {borderRadius: 8},
    palette: {
        primary: {
            main: '#008037',
            light: '#49b063',
            dark: '#00520c',
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: "rgb(203, 210, 224)"
                },
                root: {
                    '&:hover': {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgba(18, 159, 79, 0.5)",
                            boxShadow: "rgba(18, 159, 79, 0.25) 0px 0px 10px"
                        }
                    },
                }

            }
        }
    }
});
export const themeDiamond = createTheme({
    shape: {borderRadius: 8},
    palette: {
        primary: {
            main: 'rgb(186,130,66)',
            light: 'rgb(229,161,83)',
            dark: 'rgb(128,90,46)',
        }
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: "rgb(203, 210, 224)"
                },
                root: {
                    '&:hover': {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "rgb(186, 130, 66)",
                            boxShadow: "rgba(18, 159, 79, 0.25) 0px 0px 10px"
                        }
                    },
                }

            }
        }
    }
});
export default theme